var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",class:_vm.$style.component},[_c('router-link',{class:_vm.$style.link,attrs:{"to":{
      path: _vm.image.artist.url,
      query: { slide: _vm.query }
    }}},[_c('base-image',{class:_vm.$style.image,attrs:{"image":_vm.image,"sizes":"100px"}})],1),_c('image-description',{class:_vm.$style.description,attrs:{"image":_vm.image}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }